module.exports = __webpack_public_path__ + "img/no_halving_chart.6dc673c8.svg";